import { useState, useEffect } from 'react';
import * as helpers from "../utils/utils.js";
import { useClientId } from '../context/context.js';

export function useCustomerValidation() {
    const [customer, setCustomer] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        zip: "",
      });
    const [customerFormErrors, setCustomerFormErrors] = useState({});

    const clientId = useClientId();
  
    const fetchCustomer = async (id) => {
      const response = await helpers.get(`/clients/${clientId}/customers/${id}`);
      if (response.success) {
        setCustomer(response.data.customer);
        return response.data.customer;
      }

      return
      
    };
  
    const submitCustomer = async (info) => {
      const response = await helpers.post(`/clients/${clientId}/customers`, info);
      if (response.success) {
        return response.data.customer;
      }
    };

    /////// Validate renter info
    useEffect(() => {
        function validateRenterInfo(renterInfo) {
            let errors = {};

            for (let key of Object.keys(renterInfo)) {
            const value = renterInfo[key];

            if (value === "") {
                errors[key] = "This is a required field.";
            } else {
                if (key === "firstName" || key === "lastName") {
                if (!/^[a-zA-Z]+(?:[-'’][a-zA-Z]+)?$/.test(value)) {
                    errors[key] = "Please enter a valid " + key;
                }
                } else if (key === "email") {
                if (
                    !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
                    value,
                    )
                ) {
                    errors[key] =
                    "Please enter a valid email address (example@gmail.com)";
                }
                } else if (key === "phone") {
                if (!/^\d{10}$/.test(value)) {
                    errors[key] =
                    "Please enter a valid US 10-digit phone number (0000000000)";
                }
                } else if (key === "address" || key === "city") {
                if (!/^[a-zA-Z0-9\s,'’#\-\.]+$/.test(value)) {
                    errors[key] = "Please enter a valid " + key;
                }
                } else if (key === "zip") {
                if (!/^\d{5}(?:-\d{4})?$/.test(value)) {
                    errors[key] = "Please enter a valid zip code (00000)";
                }
                }
            }
            }

            setCustomerFormErrors(errors);
        }

        validateRenterInfo(customer);
    }, [customer]);
  
    return {
      customer,
      setCustomer,
      customerFormErrors,
      fetchCustomer,
      submitCustomer,
    };
  }
  